const fonts = {
  roboto: "'Plus Jakarta Sans', sans-serif",
  display: "'Bricolage Grotesque', sans-serif",
};

export default fonts;
